import React, {Component} from 'react'
import './RecordListBody.css'
import RecordListTable from './RecordListTable'
import RecordSearchArea from './RecordSearchArea'
import RecordPageFunctionArea from './RecordPageFunctionArea'
import WarningDialog from '../../FunctionArea/WarningDialog'
import SelectMovieColumnArea from './SelectMovieColumnArea'
import MovieRecordContainer from './MovieRecordContainer'
import {server_ip} from '../../../ipAddress'

class RecordListBody extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fullScreen:false,
            listData:null,
            limitNumber:50,
            pageNumber:1,
            totalNumber:0,
            orderType:"ASC",
            orderColumn:"Movie_SysID",
            searchWord:null,
            searchType:"basic",
            searchColumn:"All",
            showWarningDialog:false,
            deleteRowID:null,
            showColumnSelectedModal:false,
            movieMountToggle:null,
            columnStatus:null,
            sessionInfo:null,
            selectedRecordSysID:null,
            showRecordcontain:null,
        }
    }

    componentDidMount(){
        this.getAllRecord()
        .then(res=>{
                this.setState({
                listData:res,
                totalNumber:res[0].Movie_TotalCount,
                columnStatus:this.initialState()
            })             
        })

        if(this.props.userID)
        {
            this.sessionCheck()
        }

        window.addEventListener("beforeunload",(e)=>{ 
            e.preventDefault()    
            return this.freeMovieSession()
        })

       
    }

    componentDidUpdate(prevProps, prevState){
        console.log("componentDidUpdate...")
        if(prevState.limitNumber !== this.state.limitNumber || prevState.pageNumber !== this.state.pageNumber || prevState.orderType !== this.state.orderType || prevState.orderColumn !== this.state.orderColumn || prevState.searchWord !== this.state.searchWord || prevState.searchType !== this.state.searchType || prevState.searchColumn !== this.state.searchColumn)
        {
            console.log("A1")
            this.refreshSearch()
        }
        else
        {
            console.log("A2")
        }
    }

    componentWillUnmount(){
        this.props.getMovieSession(null)
        window.removeEventListener("beforeunload", this.freeMovieSession())
    }

    sessionCheck=async()=>{
        let result = await this.checkSessionResult(this.props.userID)
        if(result.sessionAvaliable)
        {
            console.log('Movie Session free')
            this.setMovieSession(this.props.userID)
        }
        else
        {
            console.log('Movie Session occupied')
        }

        this.setState({
            sessionInfo:result
        },()=>{
            this.props.getMovieSession(result)
        })
    }

    checkSessionResult=async(userID)=>{
        let msg = await fetch(server_ip+'/api/movie/check/MovieSession')
        let output = await msg.json()
        console.log(output[0])
        if(output[0].MovieSession === 0)
        {
            return {sessionAvaliable:true,sessionOccupier:null}
        }
        else
        {
            if(output[0].UserID === userID)
            {
                return {sessionAvaliable:true,sessionOccupier:null}
            }
            else
            {
                return {sessionAvaliable:false,sessionOccupier:output[0].UserName}
            }
        }
    }

    freeMovieSession=async()=>{
        console.log('freeMovieSession')
        if(this.state.sessionInfo && this.state.sessionInfo.sessionAvaliable)
        {
            let msg = await fetch(server_ip+'/api/movie/free/MovieSession',{
                method:'PUT',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            })
            //let output = await msg.json()
            console.log(msg.status)
        }      
    }
  
    setMovieSession=async(userID)=>{
        let tempBody = {
            'UserID':userID
        }
        
        let msg = await fetch(server_ip+'/api/movie/set/MovieSession',{
            method:'PUT',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body:this.getEncodeFormBody(tempBody)
        })
        let output = await msg.json()
        console.log(output[0])
    }
  
    getEncodeFormBody=(formObject)=>{
        let formBody =[]
        for (let property in formObject) 
        {
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(formObject[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        return formBody
    }

    refreshSearch=()=>{
        if(this.state.searchType === "basic" && !this.state.searchWord)
        {
            console.log("refreshSearch")
            console.log("A1-1")
           
            this.getAllRecord()
            .then(res=>{
                this.setState({
                    showWarningDialog:false,
                    listData:res,
                    totalNumber:res[0]? res[0].Movie_TotalCount:0
                })             
            })
        }
        else if(this.state.searchType === "basic" && this.state.searchWord)
        {
            console.log("A1-2")
            this.getRecordByBasicSearch()
            .then(res=>{
                if(res[0])
                {
                    this.setState({
                        showWarningDialog:false,
                        listData:res,
                        totalNumber:res[0]?res[0].Movie_TotalCount:0,
                    })     
                }
                else
                {
                    this.setState({
                        showWarningDialog:false,
                        listData:null,
                        totalNumber:0,
                    })
                }             
            })
        }
        else if(this.state.searchType === "advance")
        {
            console.log("A1-3")
            this.getRecordByAdvanceSearch()
            .then(res=>{
                if(res[0])
                {
                    this.setState({
                        showWarningDialog:false,
                        listData:res,
                        totalNumber:res[0].Movie_TotalCount,
                    })     

                }
                else
                {
                    this.setState({
                        showWarningDialog:false,
                        listData:null,
                        totalNumber:0,
                    })
                }             
            })
        }
        else
        {
            console.log("A1-4")
        }
    }

    initialState=()=>{
        let columnStatusArray = [
            {
                columnID:1,
                columnName:"Movie_SubCategoryOne",
                columnTitle:"長短片",
                width:60,
                status:true
            },
            {
                columnID:2,
                columnName:"Movie_SubCategoryTwo",
                columnTitle:"種類",
                width:60,
                status:true
            },
            {
                columnID:3,
                columnName:"Movie_TitleTranslation",
                columnTitle:"翻譯片名",
                width:150,
                status:true
            },
            {
                columnID:4,
                columnName:"Movie_TitleOther",
                columnTitle:"其他片名",
                width:150,
                status:true
            },
            {
                columnID:5,
                columnName:"Movie_ProductionDate",
                columnTitle:"出品年代",
                width:70,
                status:true
            },
            {
                columnID:6,
                columnName:"Movie_ProductionLocation",
                columnTitle:"出品地點",
                width:70,
                status:true
            },
            {
                columnID:7,
                columnName:"Movie_ProductionCompany",
                columnTitle:"出品公司",
                width:150,
                status:true
            },
            {
                columnID:8,
                columnName:"Movie_Producer",
                columnTitle:"出品人",
                width:70,
                status:true
            },
            {
                columnID:9,
                columnName:"Movie_DramaContent",
                columnTitle:"故事大綱",
                width:800,
                status:true
            },
            {
                columnID:10,
                columnName:"Movie_Rating",
                columnTitle:"電影分級",
                width:70,
                status:true
            },
            {
                columnID:11,
                columnName:"Movie_Language",
                columnTitle:"語言",
                width:60,
                status:true
            }
        ]

        return columnStatusArray
    }

    getAllRecord = async()=>{
        console.log("proceed getAllRecord...")
        let limitNumber = this.state.limitNumber
        let pageNumber = this.state.pageNumber
        let orderType = this.state.orderType
        let orderColumn = this.state.orderColumn
        let msg = await fetch(server_ip+'/api/movie/basicQuery/backend/limit/'+limitNumber+'/pageNumber/'+pageNumber+'/orderColumn/'+orderColumn+'/orderType/'+orderType+'/query/default')

        let output = await msg.json()
        if(msg.status !== 200) throw Error(msg.message)
        //console.log(output)
        return output
    }

    getRecordByBasicSearch = async()=>{
        console.log("proceed getRecordByBasicSearch...")
        let limitNumber = this.state.limitNumber
        let pageNumber = this.state.pageNumber
        let orderType = this.state.orderType
        let orderColumn = this.state.orderColumn
        let queryWords = encodeURI(JSON.stringify(this.state.searchWord))
        console.log("limitNumber : ",limitNumber)
        console.log("pageNumber : ",pageNumber)
        console.log("orderType : ",orderType)
        console.log("orderColumn : ",orderColumn)
        console.log("queryWords : ",queryWords)
        let msg = await fetch(server_ip+'/api/movie/basicQuery/backendv2/limit/'+limitNumber+'/pageNumber/'+pageNumber+'/orderColumn/'+orderColumn+'/orderType/'+orderType+'/query/'+queryWords)

        let output = await msg.json()
        if(msg.status !== 200) throw Error(msg.message)
        console.log(output)
        return output
    }

    getRecordByAdvanceSearch = async()=>{
        console.log("proceed getRecordByAdvanceSearch...")
        let limitNumber = this.state.limitNumber
        let pageNumber = this.state.pageNumber
        let orderType = this.state.orderType
        let orderColumn = this.state.orderColumn
        let queryWords = encodeURI(JSON.stringify(this.state.searchWord))
        console.log("limitNumber : ",limitNumber)
        console.log("pageNumber : ",pageNumber)
        console.log("orderType : ",orderType)
        console.log("orderColumn : ",orderColumn)
        console.log("queryWords : ",queryWords)
        let msg = await fetch(server_ip+'/api/movie/advanceQuery/backend/limit/'+limitNumber+'/pageNumber/'+pageNumber+'/orderColumn/'+orderColumn+'/orderType/'+orderType+'/query/'+queryWords)

        let output = await msg.json()
        if(msg.status !== 200) throw Error(msg.message)
        //console.log(output)
        return output

    }

    getOrderStatus=(msg)=>{
        console.log("EventListBody getOrderStatus")
        console.log(msg)
       
        this.setState({
            orderColumn:msg.orderColumn,
            orderType:msg.orderType
        })
    }

    getSearchInfo=(msg)=>{
        console.log("getSearchInfo...")
        console.log(msg)
        
        if(this.state.searchWord !== msg)
        {
            this.setState({
                searchType:msg.type,
                searchWord:msg.searchWord,
                listData:null,
                limitNumber:50,
                pageNumber:1,
                totalNumber:0,
                orderType:"ASC",
                orderColumn:"Movie_SysID",
                searchColumn:"All",
            })
        }                
    }

    getPageLimitInfo=(msg)=>{
        if(this.state.limitNumber !== msg)
        {
            this.setState({
                limitNumber:msg,
                pageNumber:1
            })
        }
    }

    getPageNumberInfo=(msg)=>{
        if(this.state.pageNumber !== msg)
        {
            this.setState({
                pageNumber:msg
            })
        }
    }

    getSelectedRecord=(msg)=>{
        if(this.state.selectedRecordSysID !== msg)
        {
            this.setState({
                selectedRecordSysID:msg,
                showRecordcontain:true
            })
        }
    }

    toggleColumnSelectedModal=(toggle)=>{
        if(this.state.showColumnSelectedModal !== toggle)
        {
            this.setState({
                showColumnSelectedModal:toggle
            })
        }
    }

    getColumnStatus=(msg)=>{
        if(this.state.columnStatus !== msg)
        {
            this.setState({
                columnStatus:msg
            })
        }
    }

    setMovieMountStatus=async()=>{
        
        if(this.state.movieMountToggle)
        {
            let msg = await fetch(server_ip+'/api/movie/update/MovieMountStatus',{
                method:'PUT',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body:this.getEncodeFormBody(this.state.movieMountToggle)
            })
            //let output = await msg.json()
            console.log(msg.ok)
            if(msg.ok)
            {
                this.refreshSearch()
            }
        }  
    }
  
    toggleMountOrUnmount=(msg)=>{
        console.log("toggleMountOrUnmount clicked!")
        console.log(msg)
        this.setState({
            showWarningDialog:true,
            movieMountToggle:msg
        })
        //this.setMovieMountStatus(msg)
    }

    cancelUpdateMovieMount=()=>{
        this.setState({
            showWarningDialog:false,
            movieMountToggle:null
        })
    }

    render(){
        let parentNotFullScreen = {
            position:'relative',
        }

        return(
            <div style={parentNotFullScreen} tabIndex='0'>            
                <WarningDialog from={this.state.sessionInfo && this.state.sessionInfo.sessionAvaliable? "MovieMountStatusChange":"MovieSessionOccupied"} msg={this.state.movieMountToggle} showWarningDialog={this.state.showWarningDialog} confirm={this.state.sessionInfo && this.state.sessionInfo.sessionAvaliable?this.setMovieMountStatus:this.cancelUpdateMovieMount} cancel={this.cancelUpdateMovieMount}/>
                {this.state.showRecordcontain? <MovieRecordContainer movieSysID={this.state.selectedRecordSysID} keywords={this.state.searchWord} closeModal={()=>this.setState({selectedRecordSysID:null,showRecordcontain:false})}/>:null}
                <div>               
                    <RecordSearchArea getSearchInfo={this.getSearchInfo} />
                    <RecordPageFunctionArea getPageLimitInfo={this.getPageLimitInfo} getPageNumberInfo={this.getPageNumberInfo} storedLimitNumber={this.state.limitNumber} storedPageNumber={this.state.pageNumber} storedTotalNumber={this.state.totalNumber}>
                        {this.state.listData?<RecordListTable fullScreen={this.state.fullScreen} listData={this.state.listData} columnStatus={this.state.columnStatus} limitNumber={this.state.limitNumber} pageNumber={this.state.pageNumber} getOrderStatus={this.getOrderStatus} storedOrderColumn={this.state.orderColumn} storedOrderType={this.state.orderType} getSelectedRecord={this.getSelectedRecord} openColumnSelectedModal={this.toggleColumnSelectedModal} toggleMountOrUnmount={this.toggleMountOrUnmount} keywords={this.state.searchWord}/>:null}
                        {this.state.showColumnSelectedModal? <SelectMovieColumnArea columnStatus={this.state.columnStatus} closeColumnSelectedModal={this.toggleColumnSelectedModal} getColumnStatus={this.getColumnStatus}/> :null} 
                    </RecordPageFunctionArea>            
                </div>
            </div>
        )
    }
}

export default RecordListBody